<template>
  <div>
    <list
      row-key="RecordId"
      ref="list"
      unit="入库单"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
      @on-reset="onResetQuery"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="入库单号">
          <el-input
            v-model="params.IndocCode"
            placeholder="请输入入库单号"
            clearable
          />
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input
            v-model="params.GoodsName"
            placeholder="请输入商品名称"
            clearable
          />
        </el-form-item>
        <!--  <el-form-item label="规格型号">
          <el-input
            v-model="params.GoodsModel"
            placeholder="请输入规格型号"
            clearable
          />
        </el-form-item>-->
        <el-form-item label="规格型号">
          <el-input
            v-model="params.AttributeName"
            placeholder="请输入规格型号"
            clearable
          />
        </el-form-item>
        <el-form-item label="入库日期">
          <range-picker
            ref="picker"
            @change="
              (x) => {
                params.IndocDateStart = x.Start;
                params.IndocDateEnd = x.End;
              }
            "
          />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="params.State" placeholder="请选择状态" clearable>
            <el-option label="草稿" :value="0"></el-option>
            <el-option label="待审" :value="1"></el-option>
            <el-option label="通过" :value="2"></el-option>
            <el-option label="不通过" :value="3"></el-option>
            <!-- <el-option label="作废" :value="4"></el-option> -->
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="所属商家" v-if="loginInfo.UserType == 0">
          <el-select
            v-model="params.StoreId"
            @change="onChange"
            placeholder="请选择商家"
            filterable
            clearable
          >
            <el-option
              v-for="item in busiList"
              :key="item.RecordId"
              :label="item.BusiName"
              :value="item.RecordId"
            ></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="入库仓库">
          <el-select
            v-model="params.WhId"
            placeholder="请选择入库仓库"
            clearable
            filterable
          >
            <el-option
              v-for="(i, k) in whList"
              :key="k"
              :label="i.WhName"
              :value="i.RecordId"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">  
        <!-- <el-table-column
          prop="StoreName"
          label="所属商家"
          v-if="loginInfo.UserType == 0"
        /> -->
        <el-table-column prop="IndocCode" label="入库单号" />
        <el-table-column prop="IndocDate" label="入库日期">
          <template slot-scope="{ row }">{{
            $commonJs.toDateString(row.IndocDate)
          }}</template>
        </el-table-column>
        <el-table-column prop="WhName" label="入库仓库" />
        <el-table-column prop="GoodsCount" label="数量" />
        <el-table-column prop="SumAmount" label="金额" />
        <el-table-column prop="State" width="80px" label="状态" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.State == 0">草稿</span>
            <span v-if="row.State == 1">待审</span>
            <span v-if="row.State == 2">通过</span>
            <span v-if="row.State == 3">不通过</span>
            <!-- <span v-if="row.State==4">作废</span> -->
          </template>
        </el-table-column>
      
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import busiSelect from "@/components/shop/business/select";

export default {
  mixins: [listMixin],
  components: { list, busiSelect },
  data() {
    return {
      api: require("@/api/wh/indoc").default,
      api2: require("@/api/shop/business").default,
      api3: require("@/api/wh/base").default,
      params: {
        WhId: null,
        WhName: "",
        IndocCode: "",
        GoodsName: "",
        GoodsModel: "",
        AttributeName: "",
        IndocDateStart: null,
        IndocDateEnd: null,
        State: null, //0草稿1待审2通过3不通过4作废
        StoreId: null,
      },
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      busiList: [],
      whList: [],
    };
  },
  mounted() {
    this.init();
   this.api3.list({}).then((res) => {
        if (res.Code == 0) this.whList = res.Data;
      });
  },
  methods: {
    init() {
      this.api2.list({ Status: 1, CheckState: 2 }).then((res) => {
        // console.log(res.Data);
        this.busiList = res.Data;
      });
    },
 
    onResetQuery() {
      if (this.$refs.picker) this.$refs.picker.clear();
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>